import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { resolveUrl } from '@apps/landing/src/app/shared/utils/resolve-url';
import { API_VERSIONS } from '@apps/landing/src/app/shared/utils/api-versions';
import { ResponseModel } from '@apps/landing/src/app/core/models/response.model';
import { ICareerOfferModel } from '@apps/landing/src/app/modules/careers/models/careeer.model';

@Injectable({
  providedIn: 'root',
})
export class CareerService {
  private http = inject(HttpClient);
  private readonly BASE_URL = resolveUrl(API_VERSIONS.V5, 'openedposition');

  getOpenedPositions(): Observable<ResponseModel<ICareerOfferModel[]>> {
    const headers = new HttpHeaders({
      'api-version': API_VERSIONS.V5,
    });

    return this.http.get<ResponseModel<ICareerOfferModel[]>>(this.BASE_URL, { headers });
  }

  getOpenedPositionById(id: string): Observable<ResponseModel<ICareerOfferModel>> {
    const headers = new HttpHeaders({
      'api-version': API_VERSIONS.V5,
    });

    return this.http.get<ResponseModel<ICareerOfferModel>>(`${this.BASE_URL}/${id}`, { headers });
  }
}
